import { Text, View } from "react-native";
import { FONT } from "../../value/staticValues";
import ContentBox from "../base/tamplate/ContentBox";

export default function Ready() {
    return (
        <ContentBox title={"서비스 준비중"} infoText={""} back={true}>
            <View style={{alignItems: "center", justifyContent: "center", height: "50vh"}}>
                <Text style={{
                    fontFamily: FONT.MEDIUM,
                    fontSize: 20,
                    color: "#333"
                }}>
                    서비스 준비중입니다.
                </Text>
            </View>
        </ContentBox>
    )
}